import React from 'react';
import { EventCountdown } from '../EventCountdown.jsx';
import { SECONDARY_LINK_CLASS, SECONDARY_LINK_ROW } from '../SecondaryLink.jsx';

// The site months out: the invitation and the game, pixel-for-pixel what
// shipped. From the final few days onward the hub takes over (HomeDayOf).
export function HomeInvitation({ isDarkMode, onStartGame, onNavigate }) {
  return (
    <div className="relative z-10 max-w-2xl text-center flex flex-col items-center">
      <div className="mb-5 sm:mb-7 w-full">
        <EventCountdown />
      </div>

      <div className="w-36 h-36 sm:w-52 sm:h-52 mb-4 flex items-center justify-center">
        <img
          src="/wedding_logo.png"
          className="max-w-full max-h-full object-contain"
          alt="Wedding Logo"
          width="600"
          height="572"
        />
      </div>

      <p
        className={`font-accent text-[11px] sm:text-xs tracking-[0.45em] uppercase mb-3 ${
          isDarkMode ? 'text-slate-400' : 'text-slate-500'
        }`}
      >
        You are joyfully invited to
      </p>
      <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight mb-3 drop-shadow-lg">
        Yisehak &amp; Lydia's Wedding
      </h1>
      <p
        className={`text-base sm:text-lg mb-6 max-w-md mx-auto leading-relaxed drop-shadow-sm ${
          isDarkMode ? 'text-slate-300' : 'text-slate-600'
        }`}
      >
        Play a quick game through our favorite memories to unlock your RSVP.
      </p>

      <button
        onClick={onStartGame}
        className="relative group overflow-hidden px-10 py-5 rounded-full bg-gradient-to-r from-primary to-secondary text-white font-extrabold text-xl shadow-[0_0_50px_rgba(194,50,106,0.5)] transition-all hover:scale-105 active:scale-95 w-full sm:w-auto mb-4"
      >
        <span className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity" />
        Start the Game to RSVP
      </button>

      <div className={SECONDARY_LINK_ROW}>
        <button onClick={() => onNavigate('rsvp')} className={SECONDARY_LINK_CLASS}>
          Skip to RSVP
        </button>
        <button onClick={() => onNavigate('guestbook')} className={SECONDARY_LINK_CLASS}>
          Skip to Guestbook
        </button>
      </div>
    </div>
  );
}
